// Announcement bar: daily countdown to midnight in the shop's India time zone, plus a rotating message strip.
class YsAnnouncement extends HTMLElement {
  #timers = [];

  connectedCallback() {
    const countdown = this.querySelector('[data-countdown]');
    const slides = Array.from(this.querySelectorAll('[data-slide]'));
    const offsetMinutes = Number(this.dataset.utcOffsetMinutes || 330);
    const units = { h: 'h', m: 'm', s: 's' };

    if (countdown) {
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        const dayMs = 86400000;
        const local = Date.now() + offsetMinutes * 60000;
        const remaining = Math.max(0, dayMs - (local % dayMs));
        const total = Math.floor(remaining / 1000);
        const h = Math.floor(total / 3600);
        const m = Math.floor((total % 3600) / 60);
        const s = total % 60;
        countdown.textContent = `${pad(h)}${units.h} : ${pad(m)}${units.m} : ${pad(s)}${units.s}`;
      };
      tick();
      this.#timers.push(setInterval(tick, 1000));
    }

    if (slides.length > 1) {
      let index = 0;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.#timers.push(
        setInterval(() => {
          const current = slides[index];
          index = (index + 1) % slides.length;
          const next = slides[index];
          current.removeAttribute('data-active');
          current.setAttribute('aria-hidden', 'true');
          if (!reduce) current.setAttribute('data-leaving', '');
          next.removeAttribute('data-leaving');
          next.setAttribute('data-active', '');
          next.removeAttribute('aria-hidden');
          setTimeout(() => current.removeAttribute('data-leaving'), 400);
        }, 3000),
      );
    }
  }

  disconnectedCallback() {
    this.#timers.forEach((id) => clearInterval(id));
    this.#timers = [];
  }
}

if (!customElements.get('ys-announcement')) customElements.define('ys-announcement', YsAnnouncement);
